<script setup>
const props = defineProps({
  text: {
    type: [String, Array],
    default: ''
  }
})

const hasErrors = computed(() => {
  if (Array.isArray(props.text)) {
    return props.text.length > 0
  }
  return !!props.text
})
</script>

<template>
  <div v-if="hasErrors" class="text-[11px] text-red-500 mt-1">
    <p v-if="typeof text === 'string'">{{ text }}</p>
    <ul v-else class="list-none space-y-0.5">
      <li v-for="(error, index) in text" :key="index">
        {{ error }}
      </li>
    </ul>
  </div>
</template>
